import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// Globally Registered Components
import './globalComponents.js'

// Globally Registered Mixins
import './globalMixins.js'

// Globally Registered Directives
import './globalDirectives.js'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
